var exports = {
  "Ij": "SearchEnginesTab.module__customEngineRow___Y3REYm",
  "LW": "SearchEnginesTab.module__customEngineActions___Y3REYm",
  "r9": "SearchEnginesTab.module__editButton___Y3REYm",
  "DT": "SearchEnginesTab.module__removeButton___Y3REYm",
  "QE": "SearchEnginesTab.module__newEngineButtonContainer___Y3REYm",
  "gC": "SearchEnginesTab.module__noEnginesText___Y3REYm",
};

module.exports = exports;
